




















import Vue from "vue";
import Carousel from "./components/Carousel.vue";
import Contato from "./components/Contato.vue";
import Footer from "./components/Footer.vue";
import Galeria from "./components/Galeria.vue";
import Header from "./components/Header.vue";
import MaisPedidos from "./components/MaisPedidos.vue";
import Parallax from "./components/Parallax.vue";

export default Vue.extend({
  name: "App",
  components: {
    Header,
    Carousel,
    MaisPedidos,
    Parallax,
    Galeria,
    Contato,
    Footer,
  },
});
